import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';
import { TrLoadingOverlayModule } from '../../tr-loading-overlay/tr-loading-overlay.module';
import { TrSpinnerButtonDirectiveModule } from '../../../directives/tr-spinner-button/tr-spinner-button.module';
import { DialogReceiptComponent } from './dialog-receipt.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        RouterModule,
        MatInputModule,
        MatFormFieldModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        TrLoadingOverlayModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ DialogReceiptComponent ],
    declarations: [ DialogReceiptComponent ],
    entryComponents: [ DialogReceiptComponent ],
})
export class DialogReceiptModule {}
